import { makeStyles } from '@material-ui/core';
import frontend_config from '../frontend_config';

const hostname = window.location.hostname;
// Usage:  const classes = usePatientsStyles();
// <compoenent className={classes.your_name_in_usePatientsStyles}> </>
// e.g className={classes.datepicker}
export const usePatientsStyles = makeStyles((theme) => ({
    datepicker: {
        margin: '2px 0px 2px 0px',
        height: '60px',
        // width: 'fit-content',
        padding: '20px 15px 10px',
        borderBottom: '2px solid blue',
        backgroundColor: '#fff',
        color: '#2c2c2c',
        width: 300,
        fontWeight: 600,
    },
    root: {
        margin: '48px auto',
        [theme.breakpoints.down('sm')]: {
            margin: '0 auto',
        },
        [theme.breakpoints.up('lg')]: {
            width: '70%',
            minHeight: '400px',
        },
    },
    linkBtn: {
        background: 'rgba(89,54,135,1)',
        color: 'white',
        padding: '4px 24px',
        fontWeight: 300,
        margin: '16px 0px',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            padding: '4px 72px',
            width: 'unset',
        },
        '&:hover': {
            background: 'rgb(77, 74, 142)',
            color: 'white',
        },
        '&:disabled': {
            background: 'grey',
            color: 'white',
        },
    },
    roundBtn: {
        background: '#00000000',
        border: `solid 1px ${frontend_config?.[hostname]?.main_color_2}`,
        color: frontend_config?.[hostname]?.main_color_2,
        padding: '4px 24px',
        fontWeight: 300,
        minWidth: 'auto',
        borderRadius: '20px',
        marginTop: '8px',
        marginRight: '8px',
        '&:hover': {
            background: frontend_config?.[hostname]?.main_color_2,
            color: 'white',
        },
    },
    roundBtnActive: {
        background: frontend_config?.[hostname]?.main_color_2,
        border: `solid 1px ${frontend_config?.[hostname]?.main_color_2}`,
        color: 'white',
        padding: '4px 24px',
        fontWeight: 300,
        minWidth: 'auto',
        borderRadius: '20px',
        marginTop: '8px',
        marginRight: '8px',
        '&:hover': {
            background: frontend_config?.[hostname]?.main_color_2,
            color: 'white',
        },
    },
    activeView: {
        background: frontend_config?.[hostname]?.main_color_2,
        border: `solid 1px ${frontend_config?.[hostname]?.main_color_2}`,
        color: 'white',
        fontWeight: 300,
        marginTop: '8px',
        marginRight: '8px',
        '&:hover': {
            background: 'rgba(89,54,135,1)',
            color: 'white',
        },
    },
    listCard: {
        borderRadius: 4,
        border: 'solid #dddddd 1px',
        boxShadow: '0 1px 2px rgba(0,0,0,0.15);',
        padding: 16,
        '&:hover': {
            boxShadow: '-2px 6px 24px -9px rgba(166,130,166,1)',
            // TODO: transition top
            // transition: "box-shadow 0.2s ease-in-out, top 1s linear",
            // top: -8,
            transition: 'box-shadow 0.2s ease-in-out',
            position: 'relative',
            // cursor: "pointer"
        },
    },
    gridIcon: {
        width: 'auto',
        height: '100px',
        [theme.breakpoints.down('sm')]: {
            height: '78px',
        },
    },
    firstLastName: {
        [theme.breakpoints.only('xs')]: {
            marginTop: '5px',
            marginBottom: '5px',
            width: '100%',
        },
    },
}));
